function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.hours em').html(hours)
      $('.minutes em').html(minutes)
      $('.seconds em').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
  //     let _swiper = new Swiper(".swiper-p2", {
  //   spaceBetween: 10,
  //   slidesPerView: 1,
  //   speed: 1,
  // });
      let spImgList = [
    "https://cdn.shopify.com/s/files/1/0776/5691/6250/files/1-1.png?v=1752220452",
    "https://cdn.shopify.com/s/files/1/0776/5691/6250/files/2-2_e4da616c-b6bb-4631-b01a-f41cf3b51b6d.png?v=1752220452",
    "https://cdn.shopify.com/s/files/1/0776/5691/6250/files/3-3_ac12a95f-4655-4e03-bb9c-4998b580c7f7.png?v=1752220452",

    "https://cdn.shopify.com/s/files/1/0776/5691/6250/files/1-1_dfa8ffc1-5287-4def-8d06-566b72b74bbb.png?v=1752220452",
    "https://cdn.shopify.com/s/files/1/0776/5691/6250/files/2-2.png?v=1752220452",
    "https://cdn.shopify.com/s/files/1/0776/5691/6250/files/3-3.png?v=1752220452",
    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-p1-3.png",
    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-p2-3.png",
    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-p3-3.png",

    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-c1.png",
    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-c2.png",
    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-c3.png",
    "https://cdn.shopify.com/s/files/1/0849/9655/5034/files/20250625-c4.png",
  ];
    new Swiper('.myWord', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
    })

    var swiper1 = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  // var _swiper = new Swiper(".swiper-p2", {
  //   spaceBetween: 10,
  //   slidesPerView: 1,
  //   speed: 1,
  // });
    var swiper2 = new Swiper('.mySwiper2', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
    
    var swiper3 = new Swiper('.mySwiper3', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      loop: true, //循环滚动
      freeMode: true,
      speed: 9500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    $('.sp-public-btn,.sp-head-btns').click(function () {
      $('.sp-mask').css('display', 'flex')
    })
    $('.close-pop').click(function () {
      $('.sp-mask').css('display', 'none')
    })
     let prods = window.product
  $('.product-part-inner #sp_price1').html((prods[0].price /100).toFixed(2))
  $('.product-part-inner #sp_price2').html((prods[0].compare_at_price /100).toFixed(2))
  $('.sp-mask #sp_price1').html((prods[0].price /100).toFixed(2))
  $('.sp-mask #sp_price2').html((prods[0].compare_at_price /100).toFixed(2))
  
  function getCur(productPart){
    let style = productPart.find('#sp-number div.active').attr('data-val')
    let size = productPart.find('#sp-color div.active').attr('data-val')
    return prods.filter(item=> item.option1 == style && item.option2 == size)[0]
  }
  function changePrice(productPart){
    let num = productPart.find('#calcNumber').val()
    let price = (getCur(productPart).price * num / 100).toFixed(2)
    let compare = (getCur(productPart).compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    console.log(price)
    productPart.find('#sp_price1').html(price)
    productPart.find('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur(productPart).price / getCur(productPart).compare_at_price * 100)
    $(".product-part .price-group .sp-row span").html(off_font);
  }
  $('.link-btn').click(function(){
    let num = $(this).siblings('.addGroup').find('input').val()
    num = num ? num : 1
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })
  function showTip() {
    // let result = $("#sp_price1").html();
    // if (result >= 50) {
    //   $(".product-part .sp-btn-tip").show();
    // } else {
    //   $(".product-part .sp-btn-tip").hide();
    // }
  }
  // $(".sp-reduce").click(function () {
  //   let input = $(this).siblings("input")[0];
  //   let num = Number(input.value) - 1;
  //   let productPart = $(this).closest('.product-part');
  //   if (num > 0) {
  //     input.value = num;
  //   }
  //   changePrice(productPart)
  //   showTip();
  // });
  // $(".sp-add").click(function () {
  //   let input = $(this).siblings("input")[0];
  //   let num = Number(input.value) + 1;
  //   let productPart = $(this).closest('.product-part');
  //   input.value = num;
  //   changePrice(productPart)
  //   showTip();
  // });
  function calcTotal(price, num) {
    let _result = Number(price) * Number(num)
    return _result.toFixed(2)
  }
  let sp_price1 = window.product[0].price / 100
  let sp_price2 = window.product[0].compare_at_price / 100
    // 数字框
  $('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    $(this)
      .parents()
      .siblings('.sp-price')
      .children()
      .children('.new')
      .html(calcTotal(sp_price1, input.value))
    $(this)
      .parents()
      .siblings('.sp-price')
      .children()
      .children('.old')
      .html(calcTotal(sp_price2, input.value))
  })
  $('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    $(this)
      .parents()
      .siblings('.sp-price')
      .children()
      .children('.new')
      .html(calcTotal(sp_price1, input.value))
    $(this)
      .parents()
      .siblings('.sp-price')
      .children()
      .children('.old')
      .html(calcTotal(sp_price2, input.value))
  })

  $(".product-part-inner .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let productPart = $(this).closest('.product-part');
    let colorOptions = $(
      ".product-part-inner #sp-color .sp-option.active"
    ).index();
    let numOptions = $(
      ".product-part-inner  #sp-number .sp-option.active"
    ).index();
    console.log(colorOptions,numOptions)
    let _index = numOptions + colorOptions * 3;

    // _swiper?.slideTo(_index);
    // $("#wrapper-1").src = 
    console.log(getCur(productPart).price / 100 >= 39.99,"getCur(productPart).price")
    if (colorOptions == 1) {
       if (numOptions == 0) {
          productPart.find(".sp-free-1").css({
            top: "141px",  
            left: "442px"  
        })
       }else if(numOptions == 1) {
          productPart.find(".sp-free-1").css({
            top: "209px",  
            left: "414px"  
          })
       }else {
         productPart.find(".sp-free-1").css(
            {
              top: "224px",
              left: "368px"
            }
          )
       }
          
      }else {
       if (numOptions == 0) {
          productPart.find(".sp-free-1").css({
            top: "162px",  
            left: "540px"  
        })
       }else if(numOptions == 1) {
          productPart.find(".sp-free-1").css({
            top: "253px",  
            left: "619px"  
          })
       }else {
         productPart.find(".sp-free-1").css({
       
            top: "306px",  // 或者直接写 306（jQuery 会自动添加 'px'）
            left: "580px"  // 或者直接写 580
        })
       }
       
      }
   
   productPart.find(".wrapper-1").attr('src',spImgList[_index])
    changePrice(productPart)
  });
  $(".sp-mask .product-part .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let productPart = $(this).closest('.product-part');

    let colorOptions = $(
      ".sp-mask .product-part #sp-color .sp-option.active"
    ).index();
    let numOptions = $(
      ".sp-mask .product-part #sp-number .sp-option.active"
    ).index();

     let _index = numOptions + colorOptions * 3;
     if (colorOptions == 1) {
       if (numOptions == 0) {
          productPart.find(".sp-free-1").css({
            top: "141px",  
            left: "442px"  
        })
       }else if(numOptions == 1) {
          productPart.find(".sp-free-1").css({
            top: "209px",  
            left: "414px"  
          })
       }else {
         productPart.find(".sp-free-1").css(
            {
              top: "224px",
              left: "368px"
            }
          )
       }
          
      }else {
       if (numOptions == 0) {
          productPart.find(".sp-free-1").css({
            top: "162px",  
            left: "540px"  
        })
       }else if(numOptions == 1) {
          productPart.find(".sp-free-1").css({
            top: "253px",  
            left: "619px"  
          })
       }else {
         productPart.find(".sp-free-1").css({
       
            top: "306px",  // 或者直接写 306（jQuery 会自动添加 'px'）
            left: "580px"  // 或者直接写 580
        })
       }
       
      }
    
    productPart.find(".wrapper-1").attr('src',spImgList[_index])
    // _swiper2.slideTo(_index);
    changePrice(productPart)
  });
    $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let productPart = $(this).closest('.product-part');
      var data = {
      id: getCur(productPart).id,
      quantity: productPart.find('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
          $('.sp-cart .sp-num').removeClass('sp-gray')
        });
      },
      dataType: "json",
    });
      var img = productPart.find(".wrapper-1");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      productPart.append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        background: "#e7e9ef",
        position: "fixed",
        top: img[0].offsetTop+600,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop,
          // top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });
    // 文字标题动画
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
      const spans = gradually.querySelectorAll('span'),
        paragraph = gradually.querySelector('.sp-sub-title'),
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                spans.forEach((span, index) => {
                  ;(span.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (span.style.animationDelay = `${index * 0.15}s`)
                  const i = span.querySelector('i')
                  i &&
                    ((i.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (i.style.animationDelay = `${index * 0.15}s`))
                })
                const totalDelay = spans.length * 0.15 + 0.3
                paragraph &&
                  ((paragraph.style.animation =
                    'swift-up-fade 0.5s ease forwards'),
                  (paragraph.style.animationDelay = `${totalDelay}s`)),
                  observer.unobserve(gradually)
              }
            })
          },
          { threshold: 0.3 }
        )
      observer.observe(gradually)
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断
  
  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
